module.exports = __webpack_public_path__ + "img/mail-services-grey.6929c827.svg";